import { useTranslation } from 'react-i18next';

function LoadingSpinner({ message }) {
    const { t } = useTranslation();

    return (
        <div className="interview-loading">
            <div className="loading-spinner" />
            <p>{message || t('common.loading')}</p>
        </div>
    );
}

export default LoadingSpinner;